import { ZOOCASA_TENANT_HEADER_NAME } from 'constants/headers';
import { MiddlewareFunction } from 'types/fetchWithRetry';
import { defaultMiddleware } from 'utils/fetchWithRetry';

const urlInterceptSegments = [
  'https://search-stage.zoocasa.com',
  'https://search.t.zoocasa.com',
  'https://search.zoocasa.com',
  '/api/search',
  '/api/map',
  '/api/search-predictions',
];

/**
 * Middleware factory to create a middleware that injects the tenant header.
 *
 * @param tenantHeaderValue The value to set for the tenant header.
 * @param tenantHeaderName The name of the tenant header. Defaults to {@link ZOOCASA_TENANT_HEADER_NAME}.
 * @returns The middleware function.
 */
export function createTenantHeaderMiddleware(tenantHeaderValue: string, tenantHeaderName: string = ZOOCASA_TENANT_HEADER_NAME): MiddlewareFunction {
  return async (url, options) => {
    // Check if the URL matches any of the intercept segments
    if (tenantHeaderValue && urlInterceptSegments.some(segment => url.includes(segment))) {
      // Ensure headers object exists and is properly initialized
      const headers = new Headers(options.headers || {});

      // Only set if not already present
      if (!headers.has(tenantHeaderName)) {
        headers.set(tenantHeaderName, tenantHeaderValue);
      }

      // Update the options with the new headers
      options.headers = headers;
    }

    return await defaultMiddleware(url, options);
  };
}